// Ausserbetriebsetzung

// state
const state = {
    sweepstakeTermsAccepted: false,
    wantsNewsletter: false,
    productInterests: [],
}

// getters
const getters = {
}

// actions
const actions = {

}

// mutations
const mutations = {
    setSweepstakeTermsAccepted(state, newValue) {
        state.sweepstakeTermsAccepted = newValue;
    },
    setProductInterests(state, newValue) {
        state.productInterests = newValue;
    },
    setWantsNewsletter(state, newValue) {
        state.wantsNewsletter = newValue;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}